module.exports = __webpack_public_path__ + "static/logo-e8975671881ee0f9bb6279c9e5d661c4.png";